import { Form, Button, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setIsLoading } from '../general/actions';
import React, { useEffect, useRef, useState } from 'react';
import axiosInstance from '../general/axiosInstance';
import { HOST } from '../general/utils';
import AgreementList from './agreementList';

const KNOWN_CITIES = [
    { id: '05001', name: 'Medellin' },
    { id: '11001', name: 'Bogota D.C.' },
];

function Organization(props) {
    const { setIsLoading } = props;

    const [messageType, setMessageType] = useState('');
    const [message, setMessage] = useState('');
    const [organization, setOrganization] = useState({ name: '', phone: '', ext_id: '', address: '', city_id: '' });

    // Logo
    const fileInputRef = useRef(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [uploadingLogo, setUploadingLogo] = useState(false);
    const [logoMsg, setLogoMsg] = useState({ text: '', type: '' });
    const [logoTimestamp, setLogoTimestamp] = useState(Date.now());

    const orgLogoUrl = organization.id
        ? `${HOST}storage/images/logos/organization-${organization.id}.jpg?t=${logoTimestamp}`
        : null;

    const getOrganization = () => {
        if (organization.name) return;
        setIsLoading(true);
        axiosInstance.get('/organizations/current')
            .then(response => { setOrganization(response.data); })
            .catch(error => { setMessageType('danger'); setMessage(error.response.data.message); })
            .finally(() => setIsLoading(false));
    };

    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setLogoFile(file);
        setLogoPreview(URL.createObjectURL(file));
        setLogoMsg({ text: '', type: '' });
    };

    const uploadLogo = async () => {
        if (!logoFile) return;
        setUploadingLogo(true);
        setLogoMsg({ text: '', type: '' });
        try {
            const formData = new FormData();
            formData.append('image', logoFile);
            await axiosInstance.post(`/organizations/${organization.id}/logo`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            setLogoMsg({ text: 'Logo actualizado correctamente', type: 'success' });
            setLogoFile(null);
            setLogoPreview(null);
            setLogoTimestamp(Date.now());
        } catch (err) {
            setLogoMsg({ text: err?.response?.data?.message || 'Error al subir el logo', type: 'danger' });
        } finally {
            setUploadingLogo(false);
            if (fileInputRef.current) fileInputRef.current.value = '';
        }
    };

    const cancelLogoPreview = () => {
        setLogoFile(null);
        setLogoPreview(null);
        setLogoMsg({ text: '', type: '' });
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    const update = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await axiosInstance.put('/organizations/' + organization.id, organization);
            setMessageType('success');
            setMessage('Informacion actualizada correctamente');
        } catch (error) {
            setMessageType('danger');
            setMessage(error.response.data.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setMessage('');
        if (!organization.name) getOrganization();
    }, []);

    const field = (label, key, type = 'text') => (
        <div style={{ flex: 1, minWidth: 180 }}>
            <Form.Label className="report-field-label">{label}</Form.Label>
            <Form.Control
                type={type}
                value={organization[key] || ''}
                required
                onChange={(e) => setOrganization({ ...organization, [key]: e.target.value })}
            />
        </div>
    );

    return (
        <>
            {/* Header */}
            <div className="order-page-header">
                <div>
                    <div className="order-page-title">
                        <i className="fa fa-building" style={{ color: 'var(--abi-primary)', fontSize: 18 }} />
                        {organization.name || 'Entidad'}
                        {organization.id && (
                            <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--abi-muted)' }}>
                                #{organization.id} &middot; {organization.ext_id}
                            </span>
                        )}
                    </div>
                </div>
            </div>

            <Form onSubmit={update}>
                {/* Informacion general */}
                <div className="order-section">
                    <div className="order-section-header">
                        <i className="fa fa-id-card-o" /> Informacion general
                    </div>
                    <div className="order-section-body">
                        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                            {field('NIT / Ext ID', 'ext_id')}
                            {field('Nombre de la entidad', 'name')}
                        </div>
                        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 4 }}>
                            {field('Telefono', 'phone')}
                            {field('Direccion', 'address')}
                        </div>
                        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 4 }}>
                            <div style={{ flex: 1, minWidth: 180 }}>
                                <Form.Label className="report-field-label">Ciudad</Form.Label>
                                <Form.Select
                                    value={organization.city_id || ''}
                                    onChange={(e) => setOrganization({ ...organization, city_id: e.target.value || null })}
                                >
                                    <option value="">Sin ciudad</option>
                                    {KNOWN_CITIES.map(c => (
                                        <option key={c.id} value={c.id}>{c.name}</option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Logo */}
                {organization.id && (
                    <div className="order-section" style={{ marginTop: 16 }}>
                        <div className="order-section-header">
                            <i className="fa fa-image" /> Logo de la organizacion
                        </div>
                        <div className="order-section-body">
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 24, flexWrap: 'wrap' }}>

                                {/* Imagen actual o preview */}
                                <div style={{ flexShrink: 0 }}>
                                    <div style={{
                                        width: 140, height: 140, borderRadius: 12,
                                        border: '1px solid var(--abi-border)',
                                        background: '#f8fafc',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        overflow: 'hidden',
                                    }}>
                                        <img
                                            key={logoPreview || logoTimestamp}
                                            src={logoPreview || orgLogoUrl}
                                            alt="Logo"
                                            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
                                            }}
                                        />
                                        <div style={{
                                            display: 'none', flexDirection: 'column',
                                            alignItems: 'center', color: 'var(--abi-muted)', fontSize: 12,
                                        }}>
                                            <i className="fa fa-image" style={{ fontSize: 32, marginBottom: 6, opacity: 0.3 }} />
                                            Sin logo
                                        </div>
                                    </div>
                                    {logoPreview && (
                                        <div style={{ fontSize: 11, color: 'var(--abi-muted)', textAlign: 'center', marginTop: 4 }}>
                                            Vista previa
                                        </div>
                                    )}
                                </div>

                                {/* Controles de subida */}
                                <div style={{ flex: 1, minWidth: 200 }}>
                                    <p style={{ fontSize: 13, color: 'var(--abi-muted)', marginBottom: 12 }}>
                                        Formatos admitidos: JPG, PNG, WEBP. Maximo 4 MB.
                                        La imagen se redimensionara automaticamente a 720 px de ancho.
                                    </p>
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        accept="image/jpeg,image/png,image/webp"
                                        style={{ display: 'none' }}
                                        onChange={onFileChange}
                                    />
                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                        <Button
                                            size="sm"
                                            variant="outline-primary"
                                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                            disabled={uploadingLogo}
                                        >
                                            <i className="fa fa-folder-open-o" /> Seleccionar imagen
                                        </Button>
                                        {logoFile && (
                                            <>
                                                <Button
                                                    size="sm"
                                                    variant="primary"
                                                    onClick={uploadLogo}
                                                    disabled={uploadingLogo}
                                                >
                                                    {uploadingLogo
                                                        ? <span><i className="fa fa-spinner fa-spin" /> Subiendo...</span>
                                                        : <span><i className="fa fa-upload" /> Subir logo</span>
                                                    }
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    variant="outline-secondary"
                                                    onClick={cancelLogoPreview}
                                                    disabled={uploadingLogo}
                                                >
                                                    <i className="fa fa-times" /> Cancelar
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                    {logoFile && (
                                        <div style={{ fontSize: 12, color: 'var(--abi-muted)', marginTop: 8 }}>
                                            <i className="fa fa-file-image-o" /> {logoFile.name}
                                        </div>
                                    )}
                                    {logoMsg.text && (
                                        <Alert variant={logoMsg.type} className="py-2 mt-3" style={{ fontSize: 13 }}>
                                            {logoMsg.text}
                                        </Alert>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {message && (
                    <Alert variant={messageType || 'warning'} className="py-2" style={{ fontSize: 13 }}>
                        {message}
                    </Alert>
                )}

                <div className="order-form-footer">
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant="primary" type="submit" size="sm">
                            <i className="fa fa-save" /> Guardar cambios
                        </Button>
                    </div>
                </div>
            </Form>

            {/* Contratos */}
            <div className="order-section" style={{ marginTop: 20, overflowX: 'auto' }}>
                <AgreementList />
            </div>
        </>
    );
}

function mapStateToProps(state) { return { isLoading: state.isLoading }; }
const mapDispatchToProps = { setIsLoading };
export default connect(mapStateToProps, mapDispatchToProps)(Organization);
